/** Memoize using Session Store **/
import Cache, { memoize, MemStorage } from './cache';

export * from './cache';
export { default as Cache } from './cache';

const DEFAULT_TTL = 60000;

window.memStorage = new MemStorage();
const Memoize = (instance, methods = []) => {
  const cache = new Cache(window.memStorage);
  const wrap = memoize(cache);

  methods.forEach(({ keygen, name, ttl }) => {
    ttl = ttl || DEFAULT_TTL;

    const _methodCall = wrap({
      keygen,
      name,
      ttl,
      method: instance[name].bind(instance),
    });
    Object.defineProperty(instance, name, {
      value: (...args) => {
        return _methodCall(args);
      }
    });
  });
  return instance;
};

export default Memoize;
